<!--
 * @Author: yyl
 * @Date: 2025-06-26 08:55:40
 * @LastEditTime: 2025-11-03 09:52:19
 * @LastEditors: yyl
 * @Description: 
 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/components/home/CardOneColumn.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div class="card" style="min-height: 300px">
    <div class="card-title flex items-center content-space-between">
      <div class="card-title--left">
        <i :class="`el-icon-${icon}`"></i>
        {{ hasTitle ? params.title : "" }}
      </div>

      <div
        v-if="params.section_id"
        class="card-title--right"
        @click="handleGoListClick"
      >
        更多>
      </div>
    </div>

    <div v-if="hasTop && params.articles.length > 0">
      <div class="item-top">
        <el-image
          :src="oneData.thumb_pic"
          fit="cover"
          style="width: 100%; height: 100px"
        ></el-image>
        <div class="item-top__title" @click="handleGoDetailClick(oneData)">
          {{ oneData.title }}
        </div>
      </div>
    </div>

    <CardList
      :sectionId="params.section_id"
      :title="params.title"
      :list-data="listData"
    ></CardList>
  </div>
</template>

<script>
import CardList from "@/components/home/CardList.vue";

export default {
  components: { CardList },

  props: {
    hasTop: {
      type: Boolean,
      default: false,
    },
    twoColumn: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
    },
    icon: {
      type: String,
    },
    hasTitle: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      oneData: {},
      listData: [],
    };
  },

  watch: {
    params: {
      deep: true,
      immediate: true, // （可选）立即触发一次
      handler() {
        this.getData();
      },
    },
  },

  mounted() {},

  methods: {
    getData() {
      const articles = this.params.articles || [];

      if (this.hasTop || this.twoColumn) {
        this.oneData = articles[0] || {};
        this.listData = articles.filter((item) => item.id != this.oneData.id);
      } else {
        this.listData = articles;
      }

      // console.log(` this.listData`, this.listData)
    },

    handleGoListClick() {
      const item = this.params;

      console.log(item);

      if (this.params.content_model_id == 2) {
        this.$router.push({
          path: "/list",
          query: {
            section_id: String(item.section_id),
            title: item.title,
          },
        });
      } else if (this.params.content_model_id == 3) {
        this.$router.push({
          path: "/list-image",
          query: {
            section_id: String(item.section_id),
            title: item.title,
          },
        });
      } else if (this.params.content_model_id == 4) {
        this.$router.push({
          path: "/teachers",
          query: {
            section_id: String(item.section_id),
            title: item.title,
          },
        });
      }

      // this.$router.push(
      //   `/list?section_id=${this.params.section_id}&title=${this.params.title}`
      // )
    },
    handleGoDetailClick(item) {
      this.$router.push(`/article?id=${item.id}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  // min-height: 300px;
  color: #565656;
  font-size: 16px;
  overflow: hidden;
}

.card-title {
  padding: 0 4px;
  border-bottom: 3px solid #b4d13d;
}

.card-title--left {
  color: #42679f;
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  padding: 14px 0;
}

.card-title--right {
  font-size: 14px;
  line-height: 18px;
  text-align: right;
  padding: 14px 0;
  cursor: pointer;
}

.card-image {
  display: block;
  width: 100%;
  height: 324px;
  // background-color: skyblue;
}

.card-content {
  font-size: 15px;
  padding: 10px 0;
  // min-height: 42px;
  cursor: pointer;
  &:hover {
    color: #15458b;
    text-decoration: underline;
  }
}

.card-subtitle {
  font-size: 13px;
}

.item-top {
  position: relative;
}

.item-top__title {
  width: 100%;
  color: #fff;
  padding: 2px 0;
  text-indent: 6px;
  background-color: rgba($color: #000000, $alpha: 0.3);
  position: absolute;
  bottom: 4px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
</style>
